export default {
  "brand": "USFans Spreadsheet",
  "nav.spreadsheet": "Hoja de cálculo",
  "nav.guides": "Guías",
  "nav.reviews": "Reseñas",
  "nav.shipping": "Envío",
  "nav.comparisons": "Comparaciones",
  "nav.safety": "Seguridad",
  "nav.categories": "Categorías",
  "nav.resources": "Recursos",
  "nav.home": "Inicio",
  "nav.buyingGuide": "Guía de compras",
  "lang.label": "Idioma",
  "cta.explore": "Explorar USFans Spreadsheet",
  "cta.buyNow": "Comprar ahora",
  "cta.viewAll": "Ver todas las guías",
  "cta.readMore": "Leer guía",
  "cta.visitStore": "Visitar la tienda",
  "article.notFound": "Artículo no encontrado",
  "article.backHome": "Volver al inicio",
  "article.faqTitle": "Preguntas frecuentes",
  "article.relatedTitle": "Guías relacionadas",
  "article.ctaTitle": "Continúa tu investigación",
  "article.ctaText": "Explora más guías o visita la tienda para poner en práctica tu investigación.",
  "footer.about": "Un centro de recursos independiente para investigar USFans Spreadsheet, guías, comparaciones, información de envío y consejos de seguridad.",
  "footer.guides": "Guías",
  "footer.company": "Empresa",
  "footer.resources": "Recursos",
  "footer.legal": "Legal",
  "footer.rights": "Todos los derechos reservados.",
  "footer.disclaimer": "Este sitio web es un recurso informativo independiente. La información puede cambiar con el tiempo. Verifique siempre los detalles importantes antes de realizar compras o compartir información personal."
};